<script>
  export let icon = '';
  export let stroke;
</script>

<style type="less">.svg-icon {
  display: block;
  height: 100%;
  width: 100%;
}
</style>

<svg class="svg-icon">
  <use xlink:href="/assets/images/icons.svg#{icon}" />
</svg>



// WEBPACK FOOTER //
// ./src/commons/navigation/SvgIcon.svelte